<div class="box" *ngIf="!accepted">
  <div class="message">
    We use cookies to improve your experience on our site. By continuing you
    accept our
    <a herf="#">Cookie Policy</a>.
  </div>
  <button class="yellow-button" (click)="onGotItClick()">Got it!</button>
</div>
